import { createFileRoute } from '@tanstack/react-router';
import { EstoqueConferenciaPage } from '@/features/estoque-conferencia/page/EstoqueConferenciaPage';

export const Route = createFileRoute('/a/estoque/conferencia')({
    component: EstoqueConferenciaPage,
});
